import { UpdatableModel } from 'projects/common/src/lib/models/updatable-model';
import { WizardStepComponent } from './wizard-step.component';

export class WizardStepEvent extends UpdatableModel<WizardStepEvent> {
  step: WizardStepComponent;
}
